<template>
    <div class="auth">
        <router-view></router-view>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
}
</script>




// WEBPACK FOOTER //
// auth.vue?72da533f